<bd-nav-progress />
<router-outlet></router-outlet>
